<template>
  <el-form ref="form" label-width="120px" class="entry-audit-dialog">
    <!--
      let errors = {
        shortEntries: [],
        overlappingEntries: [],
        nullTaskEntries: []
      }

      let warnings = {
        longEntries: [],
        nonDefaultActivityEntries: []
      }

      -->
      <div class="body">
        <div class="warnings-section" v-if="warnings.longEntries.length !== 0 || warnings.nonDefaultActivityEntries.length !== 0">
          <h3 class="warnings-title">Warnings</h3>
          <table class="warnings-table">
            <tr v-if="warnings.longEntries.length > 0">
              <td>
                <el-tag type="warning"> 
                  {{warnings.longEntries.length}} entr<span v-if="warnings.longEntries.length > 1">ies</span><span v-if="warnings.longEntries.length === 1">y</span> over 6 hours long
                </el-tag>
              </td>
            </tr>
            <tr v-if="warnings.nonDefaultActivityEntries.length > 0">
              <td>
                <el-tag type="warning"> 
                  {{warnings.nonDefaultActivityEntries.length}} entr<span v-if="warnings.nonDefaultActivityEntries.length > 1">ies</span><span v-if="warnings.nonDefaultActivityEntries.length === 1">y</span> with non-default activities
                </el-tag>
              </td>
            </tr>
          </table>
        </div>
        <br/>
        <div class="errors-section" v-if="errors.shortEntries.length !== 0 || errors.overlappingEntries.length !== 0 || errors.nullTaskEntries.length !== 0">
          <h3 class="errors-title" >Errors</h3>
          <table class="errors-table">
            <tr v-if="errors.shortEntries.length > 0">
              <td>
                <el-tag type="danger"> 
                  {{errors.shortEntries.length}} entr<span v-if="errors.shortEntries.length > 1">ies</span><span v-if="errors.shortEntries.length === 1">y</span> less than 0.1 hours
                </el-tag>
              </td>
            </tr>
            <tr v-if="errors.overlappingEntries.length > 0">
              <td>
                <el-tag type="danger"> 
                  {{errors.overlappingEntries.length}} entr<span v-if="errors.overlappingEntries.length > 1">ies</span><span v-if="errors.overlappingEntries.length === 1">y</span> overlapping other entries
                </el-tag>
              </td>
            </tr>
            <tr v-if="errors.nullTaskEntries.length > 0">
              <td>
                <el-tag type="danger"> 
                  {{errors.nullTaskEntries.length}} entr<span v-if="errors.nullTaskEntries.length > 1">ies</span><span v-if="errors.nullTaskEntries.length === 1">y</span> with no task
                </el-tag>
              </td>
            </tr>
          </table>
        </div>
      </div>
    <el-form-item class="buttons">
      <el-button @click="dismiss">Cancel</el-button>
      <el-button @click="approve" type="primary" :disabled="errors.shortEntries.length > 0 || errors.overlappingEntries.length > 0 || errors.nullTaskEntries.length > 0">Approve</el-button>
    </el-form-item>
  </el-form>
</template>

<script>

export default {
  props: {
    options: Object
  },
  data () {
    let errors = this.options.errors
    let warnings = this.options.warnings

    return {
      activeNames: [],
      errors: errors,
      warnings: warnings
    }
  },
  created () {
    document.addEventListener('keypress', this.keypress)
  },
  destroyed () {
    document.removeEventListener('keypress', this.keypress)
  },
  methods: {
    keypress (e) {
      e.keyCode === 13 && this.confirmOverlapDialogIsVisible && this.adjustTimeEntry()
      e.keyCode === 13 && !e.srcElement.closest('.el-message-box__wrapper') && this.confirmSave()
    },
    save () {
      this.$emit('close')
    },
    dismiss () {
      this.$emit('close')
    },
    approve () {
      this.options.approve()
      this.$emit('close')
    }
  }
}
</script>

<style lang='scss' scoped>
  @import '../styles/common.scss';
  .buttons {
    float:right;
  }
  .el-form {
    margin-bottom:30px;
  }
  .warnings-title{
    color:$warning-color;
  }
  .errors-title{
    color:$error-color;
  }
  .warnings-section, .errors-section{
    margin:10px;
  }
  .body{
    padding-left:20px;
  }
</style>